import { render } from "./audiAssets.vue?vue&type=template&id=bb713166"
import script from "./audiAssets.vue?vue&type=script&lang=js"
export * from "./audiAssets.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__